const setSelectedJournal = async function ({ commit, state }, journalId) {
  const selectedJournal = await state.journals.find((j) => j.id === journalId);
  commit("SET_SELECTED_JOURNAL", selectedJournal);
  return selectedJournal;
};

export default setSelectedJournal;
